import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { BaseDto } from '@models/base/baseDto.model';
import { InquilinoDto } from '@models/inquilino/inquilinoDto.model';
import { InquilinosService } from '@services/inquilinos/inquilinos.service';
import { PersonasService } from '@services/personas/personas.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { isFalsy } from 'utility-types';

@Component({
  selector: 'app-buscar-persona-inquilino-sin-contrato',
  templateUrl: './buscar-persona-inquilino-sin-contrato.component.html',
  styleUrls: ['./buscar-persona-inquilino-sin-contrato.component.css']
})
export class BuscarPersonaInquilinoSinContratoComponent implements OnInit {

  inquilinoSelect: EventEmitter<BaseDto> = new EventEmitter()
  public filteredInquilinos!: Observable<InquilinoDto[]>;
  inquilinos: InquilinoDto[] = []
  public entityControl = new FormControl();
  @Output() eventEntity = new EventEmitter<InquilinoDto>();
  @Input() inquilinoEntrada!: InquilinoDto;
  @Input() idPersonaInput: number = 0;
  @Input() disable: boolean = false
  entitySelect!: InquilinoDto | null;

  constructor(
    private inquilinoService: InquilinosService,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
    private personasService: PersonasService,
    private router: Router
  ) {
  }

  ngOnInit(): void {
    this.GetAllInquilinosWithoutCurrentContrat();
    if (!isFalsy(this.idPersonaInput)) {
      this.getPersonaById(this.idPersonaInput)
      this.entityControl.setValue(!isFalsy(this.inquilinoEntrada) ? this.inquilinoEntrada.persona.descripcion : "")
    }
  }

  selectValue(event: any) {
    if (isFalsy(event)){
      this.entitySelect=null
      this.entityControl.setValue("")
    }
    this.eventEntity.emit(event)
  }


  ngOnChanges(): void {
    if (!isFalsy(this.idPersonaInput)) {
      this.getPersonaById(this.idPersonaInput)
    }

    this.entityControl.setValue(!isFalsy(this.inquilinoEntrada) ? this.inquilinoEntrada.persona.descripcion : "")
  }

  findOption(val: string) {
    this.spinner.show("spBusquedaInqSinCon")
    for (let i = 0; i < this.inquilinos.length; i++) {
      if (this.inquilinos[i].persona.descripcion.toUpperCase() == val.toUpperCase()) {
        this.eventEntity.emit(this.inquilinos[i])
        this.entitySelect = this.inquilinos[i]
      }
    }
    this.spinner.hide("spBusquedaInqSinCon")
    return this.inquilinos.filter(inquilino => inquilino.persona.descripcion.toLowerCase().includes(val.toLowerCase()));
  }


  GetAllInquilinosWithoutCurrentContrat() {
    this.spinner.show("spBusquedaInqSinCon")
    this.inquilinoService.GetAllInquilinosWithoutCurrentContrat()
      .subscribe(
        data => {
          this.spinner.hide("spBusquedaInqSinCon")
          this.inquilinos = data.sort((a, b) => a.persona.descripcion.localeCompare(b.persona.descripcion));
          this.filteredInquilinos = this.entityControl.valueChanges.pipe(
            startWith(''),
            map((term: any) => this.findOption(term))
          );
        },
        error => {
          this.spinner.hide("spBusquedaInqSinCon")
          this.snackBar.showError(error, "Error");
        });
  }

  getPersonaById(idPersona: any) {
    this.inquilinoService.getInquilinoByIdPersona(idPersona)
      .subscribe(
        data => {
          const personaInquilinoDto = new InquilinoDto
          personaInquilinoDto.persona.id = data.persona.id
          personaInquilinoDto.persona.descripcion = data.persona.descripcion
          personaInquilinoDto.id = data.id
          this.inquilinoEntrada = personaInquilinoDto
        },
        error => {
          this.snackBar.showError(error, "Error");
        }
      );
  }

  editarPersona(idPersona: number) {
    this.getPersonaByIdAndRoute(idPersona)
  }

  getPersonaByIdAndRoute(idPersona: number) {
    this.spinner.show("spBusquedaInqSinCon")
    this.personasService.getPersonaById(idPersona)
      .subscribe(
        data => {
          this.spinner.hide("spBusquedaInqSinCon")
          this.personasService.setPersona(data)
          this.router.navigate(["/personas/editar"])
        },
        error => {
          this.spinner.hide("spBusquedaInqSinCon")
          this.snackBar.showError(error, "Error");
        });
  }

  trackByItems(index: number, item: any): any { return item; }
}
